export const hasAccountPermission = (permissions, permission) =>
  permissions?.[permission] === true ||
  (permission === "viewAnalytics" && permissions?.viewCrossOrgAnalytics === true);
